import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ComponentsModules } from '../shared/components/components.module';
import { PipesModules } from '../shared/pipes/pipes.modules';
import { WordRoutingModule } from './word-routing.module';

import { WordComponent } from './word.component';
import { HomonymComponent } from './homonym/homonym.component';
import { HomonymDispComponent } from './homonym/homonym-disp.component';
import { HomonymDetailComponent } from './homonym-detail/homonym-detail.component';
import { HomonymListItemComponent } from './homonym/homonym-list-item.component';
import { WordListHelpComponent } from './word-list-help/word-list-help.component';
import { HomonymBoxComponent } from './homonym/homonym-box.component';
import { Homonym2Component } from './homonym2/homonym2.component';
import { Homonym2ListItemComponent } from "./homonym/homonym2-list-item.component";
import { SajaseungeoComponent } from './sajaseungeo/sajaseungeo.component';


@NgModule({
  declarations: [
    WordComponent,
    HomonymComponent,
    HomonymListItemComponent,
    HomonymDispComponent,
    HomonymDetailComponent,
    WordListHelpComponent,
    HomonymBoxComponent,
    Homonym2Component,
    Homonym2ListItemComponent,
    SajaseungeoComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    WordRoutingModule,
    ComponentsModules,
    PipesModules,
  ],
  providers: [
  ],
  exports: [
    WordComponent,
  ],
})
export class WordModule {}
